import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import area_normal from "../../../imgs/sidebar/area_normal.png";
import area_click from "../../../imgs/sidebar/area_click.png";
import device_normal from "../../../imgs/sidebar/device_normal.png";
import device_click from "../../../imgs/sidebar/device_click.png";
import schedule_normal from "../../../imgs/sidebar/schedule_normal.png";
import schedule_click from "../../../imgs/sidebar/schedule_click.png";
import energy_normal from "../../../imgs/sidebar/energy_normal.png";
import energy_click from "../../../imgs/sidebar/energy_click.png";
import alarm_normal from "../../../imgs/sidebar/alarm_normal.png";
import alarm_click from "../../../imgs/sidebar/alarm_click.png";
import './sidebar.less';
import PubSub from 'pubsub-js';

const links = [
    { to: '/admin/control', name: "Control", icon_normal: area_normal, icon_click: area_click },
    { to: '/admin/setting', name: "Device", icon_normal: device_normal, icon_click: device_click },
    { to: '/admin/schedule', name: "Schedule", icon_normal: schedule_normal, icon_click: schedule_click },
    { to: '/admin/energy', name: "Data", icon_normal: energy_normal, icon_click: energy_click },
    // { to: '/admin/alarm', name:"Alarm", icon_normal:alarm_normal ,icon_click:alarm_click }
];



export default function Sidebar() {
    const [activeIndex, setActiveIndex] = useState(); // 默认选中第一个图标

    PubSub.unsubscribe("gotoSidebar")
    PubSub.subscribe('gotoSidebar', (msg, data) => {
        handleClick(0)
    })

    const handleClick = (index) => {
        setActiveIndex(index); // 点击后更新高亮的图标
        // setActiveIndex(1)
    };

    return (
        <div className="sidebar">
            {links.map(({ to, name, icon_normal, icon_click }, index) => (
                <NavLink
                    key={index}
                    to={to}
                    className="link" // 高亮选中的图标
                    style={{ textDecoration: 'none' }}
                    onClick={() => handleClick(index)}>
                    <div className='linkItem'>
                        <img src={index === activeIndex ? icon_click : icon_normal} />
                        <span>{name}</span>
                    </div>
                </NavLink>
            ))}
        </div>
    );
}
